import { useEffect, useMemo, useState } from 'react'

const SYNC_INTERVAL_MS = 15 * 60 * 1000

interface Props {
  nextUpdateAt: string | null
  label: string
}

function minutesUntilNextSync(nextUpdateAt: string, now: number) {
  let next = new Date(nextUpdateAt).getTime()
  if (!Number.isFinite(next)) return null

  while (next <= now) next += SYNC_INTERVAL_MS
  return Math.max(1, Math.ceil((next - now) / 60_000))
}

export default function NextUsageUpdate({ nextUpdateAt, label }: Props) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 60_000)
    return () => window.clearInterval(interval)
  }, [])

  const minutes = useMemo(
    () => nextUpdateAt ? minutesUntilNextSync(nextUpdateAt, now) : null,
    [nextUpdateAt, now],
  )
  if (minutes === null) return null

  return (
    <p className="pr-0.5 text-[10px] leading-none text-faint-foreground opacity-70">
      {label.replace('%{minutes}', String(minutes))}
    </p>
  )
}
